import React, { Component } from 'react';
import PropTypes from 'prop-types';

// This component is intended to be used with Wizard to define each page/step of a wizard process
// Some props validated here are used/required by parent Wizard component
class WizardPage extends Component {
  render() {
    return (
      this.props.children || (
        <div className="slds-marketing-cloud slds-card-wrapper">
          <span className="default-wizard">Default Page {this.props.step}</span>
        </div>
      )
    );
  }
}

WizardPage.propTypes = {
  children: PropTypes.node,
  required: PropTypes.bool,
  excludeFromProgress: PropTypes.bool,
  flex: PropTypes.bool,
  step: PropTypes.string.isRequired,
  stepName: PropTypes.string
};

export default WizardPage;
